import { AdministrativeAreaDTO } from './AdministrativeAreaDTO'
import { CatchmentDTO } from './CatchmentDTO'

export class TimeStepMaxDTO {
  constructor(readonly administrativeAreas: Array<AdministrativeAreaDTO>, readonly catchments: Array<CatchmentDTO>) {}
}
